import React, { useState, useEffect } from "react";
import { loadJSON } from "../utils/jsonUtils";
import {
  verifyPassword,
  setAdminSession,
  isAdminSessionValid,
} from "../utils/passwordUtils";
import PageWrapper from "../components/PageWrapper";


const AdminLogin = ({ setAuthenticated }) => {
  const [password, setPassword] = useState("");

  useEffect(() => {
    // Si une session admin est valide, rediriger automatiquement
    if (isAdminSessionValid()) {
      setAuthenticated(true);
    }
  }, [setAuthenticated]);

  const handleLogin = async () => {
    const settings = await loadJSON("settings");

    if (settings && verifyPassword(password)) {
      // Si le mot de passe est correct, on crée une session
      setAdminSession();
      localStorage.setItem("admin_authenticated", "true");
      setAuthenticated(true);
    } else {
      alert("Mot de passe incorrect");
    }
  };

  return (
    <PageWrapper style={{ backgroundColor: "#000", marginBottom: "2rem !important" }}>
      <h2>Admin Login</h2>
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button onClick={handleLogin}>Se connecter</button>
    </PageWrapper>
  );
};

export default AdminLogin;
